// Site-wide SEO defaults — the ONE source for src/config/env.ts (zod defaults),
// plugins/vite-plugin-seo.ts (static index.html tags) and the og edge function.
// Runtime-neutral: no import.meta / process / Deno reads. Client values (fork).
export const SEO_DEFAULTS = {
  siteName: 'freshSTART CDC',
  /** PENDING PB5 — the real domain is not registered yet; override VITE_SITE_URL. */
  siteUrl: 'https://freshstartcdc.org',
  title: 'freshSTART CDC — Community Table Project',
  description:
    'FreshStart CDC is committed to building a thriving, connected, and inclusive community by providing meaningful possibilities and essential resources, fostering growth, resilience, and long-term success.',
  ogImage: '/og-logo.jpg',
} as const;
